import { UsersTableActionButtons } from "./UsersTableActionButtons";

export function UsersTableActions({
  selectedIds,
  selectedData,
  canEditUser,
  canDeleteUser,
  canResetPassword,
  userIsAdmin,
  handleEditUser,
  onEditRoles,
  openConfirm,
  confirmResetPassword,
  confirmDelete,
  confirmDeactivate,
  confirmReactivate,
  confirmForceLogout,
  onSsoBlock,
}) {
  return (
    <UsersTableActionButtons
      selectedIds={selectedIds}
      selectedData={selectedData}
      canEditUser={canEditUser}
      canDeleteUser={canDeleteUser}
      canResetPassword={canResetPassword}
      userIsAdmin={userIsAdmin}
      onEditUser={handleEditUser}
      onEditRoles={onEditRoles}
      onResetPassword={(userIds, selectedData) => {
        const selectedUsers = selectedData.filter(u => userIds.includes(u.id));
        const ssoUsers = selectedUsers.filter(u => !u.sso_bypass);

        if (ssoUsers.length > 0) {
          const message =
            ssoUsers.length === selectedUsers.length
              ? "The selected user(s) authenticate via SSO (Google Sign-In). Password reset is not available for SSO-only users."
              : `${ssoUsers.length} of the selected users authenticate via SSO and cannot have their password reset. Please deselect SSO users and try again.`;
          onSsoBlock(message);
          return;
        }

        openConfirm({
          userIds,
          title:
            userIds.length === 1
              ? "Reset password for user"
              : "Reset passwords for users",
          action: "Reset Password",
          actionLong: "reset the password for",
          onConfirm: confirmResetPassword,
          selectedUser: selectedData[0],
        });
      }}
      onDeactivateUsers={(userIds, selectedData) =>
        openConfirm({
          userIds,
          title: userIds.length === 1 ? "Deactivate user" : "Deactivate users",
          action: "Deactivate",
          actionLong: "deactivate",
          onConfirm: confirmDeactivate,
          selectedUser: selectedData[0],
        })
      }
      onReactivateUsers={(userIds, selectedData) =>
        openConfirm({
          userIds,
          title: userIds.length === 1 ? "Reactivate user" : "Reactivate users",
          action: "Reactivate",
          actionLong: "reactivate",
          onConfirm: confirmReactivate,
          selectedUser: selectedData[0],
        })
      }
      onForceLogoutUsers={(userIds, selectedData) =>
        openConfirm({
          userIds,
          title:
            userIds.length === 1 ? "Force logout user" : "Force logout users",
          action: "Force Logout",
          actionLong: "force logout",
          onConfirm: confirmForceLogout,
          selectedUser: selectedData[0],
        })
      }
      onDeleteUser={(userIds, selectedData) =>
        openConfirm({
          userIds,
          title: userIds.length === 1 ? "Delete user" : "Delete users",
          action: "Delete",
          actionLong: "delete",
          onConfirm: confirmDelete,
          selectedUser: selectedData[0],
        })
      }
    />
  );
}
